import { msg } from "@lingui/core/macro";

export const expiryTimeBeforeTimeRuleMessages = {
	name: msg({ message: "Expiry Time Before Time" }),
	description: msg({ message: "Permit expiry time must be before time" }),
	errors: {
		noEndTime: msg({ message: "Permit must have an end time" }),
		isAfter: msg({ message: "Permit Expiry Time must be before {time}" }),
	},
} as const;
